import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((msg, type = 'success', duration = 3500) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, msg, type, hiding: false }]);
    setTimeout(() => {
      setToasts(prev => prev.map(t => t.id === id ? { ...t, hiding: true } : t));
      setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 320);
    }, duration);
  }, []);

  const icons = { success: '✅', error: '❌', warning: '⚠️', info: 'ℹ️' };
  const colors = {
    success: 'linear-gradient(135deg,#16a34a,#22c55e)',
    error:   'linear-gradient(135deg,#dc2626,#ef4444)',
    warning: 'linear-gradient(135deg,#d97706,#f59e0b)',
    info:    'linear-gradient(135deg,#2563eb,#3b82f6)',
  };

  return (
    <ToastCtx.Provider value={addToast}>
      {children}
      <div style={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 99999,
        display: 'flex', flexDirection: 'column', gap: 10,
        pointerEvents: 'none', maxWidth: 360,
      }}>
        {toasts.map(t => (
          <div key={t.id} className={`toast${t.hiding ? ' hiding' : ''}`} style={{
            background: colors[t.type] || colors.info,
            color: '#fff', borderRadius: 14,
            padding: '12px 18px',
            display: 'flex', alignItems: 'center', gap: 10,
            boxShadow: '0 8px 30px rgba(0,0,0,0.2)',
            fontSize: 14, fontWeight: 600,
            minWidth: 240,
          }}>
            <span style={{ fontSize: 18 }}>{icons[t.type]}</span>
            <span style={{ flex: 1, lineHeight: 1.4 }}>{t.msg}</span>
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  return useContext(ToastCtx);
}
